var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavIconSettingsActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav-icon-settings-active",
    transform: "translate(-140 -393)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5670",
    "data-name": "Rectangle 5670",
    width: 34,
    height: 34,
    transform: "translate(140 393)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6981",
    "data-name": "Group 6981",
    transform: "translate(115.076 -145.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(-3564.906 -111.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M20.842,246.539a11.252,11.252,0,0,1,2.925,1.214l.922-.923a1.89,1.89,0,0,1,2.674,0l1.336,1.336a1.89,1.89,0,0,1,0,2.674l-.923.923a11.246,11.246,0,0,1,1.214,2.924h1.3a1.89,1.89,0,0,1,1.89,1.89v1.891a1.89,1.89,0,0,1-1.89,1.89h-1.3a11.246,11.246,0,0,1-1.214,2.924l.923.923a1.889,1.889,0,0,1,0,2.673l-1.336,1.337a1.89,1.89,0,0,1-2.674,0l-.922-.923a11.286,11.286,0,0,1-2.925,1.214v1.3a1.89,1.89,0,0,1-1.89,1.89h-1.89a1.891,1.891,0,0,1-1.891-1.89v-1.3a11.28,11.28,0,0,1-2.924-1.214l-.923.923a1.889,1.889,0,0,1-2.673,0l-1.337-1.337a1.892,1.892,0,0,1,0-2.673c.489-.488.923-.923.923-.923a11.315,11.315,0,0,1-1.214-2.924h-1.3a1.891,1.891,0,0,1-1.891-1.89v-1.891a1.891,1.891,0,0,1,1.891-1.89h1.3a11.315,11.315,0,0,1,1.214-2.924l-.923-.923a1.893,1.893,0,0,1,0-2.674l1.337-1.336a1.889,1.889,0,0,1,2.673,0l.923.923a11.246,11.246,0,0,1,2.924-1.214v-1.3a1.891,1.891,0,0,1,1.891-1.89h1.89a1.89,1.89,0,0,1,1.89,1.89Z",
    transform: "translate(3589 409)",
    fill: "none",
    stroke: "#190a4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M18.007,251.852a5.67,5.67,0,1,1-5.671,5.671A5.674,5.674,0,0,1,18.007,251.852Z",
    transform: "translate(3589 409)",
    fill: "none",
    stroke: "#190a4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconSettingsActive);
export default __webpack_public_path__ + "static/media/nav-icon-settings-active.eaf7f4be5935bfc3a1efd2775811f806.svg";
export { ForwardRef as ReactComponent };